import { createApp } from 'vue'
import { loadTranslations } from '@/js/global/vue-i18n'
import ArticlesApp from '@/components/articles/App.vue'
import router from './article-router.js'

const app = createApp(ArticlesApp)

loadTranslations(app).then(() => {
    app.use(router)
    app.mount('#articles-vue')
})
